import styled from 'styled-components';

export const RootWrapper = styled.div``;